import $ from 'jquery';
; (globalThis as any).$ = $;
; (globalThis as any).jQuery = $;

import('./globals');
import('./main');